<template>
  <ui-progress-circle
    class="animate-spin"
    :paused="true"
    model-value="80"
    duration="50000"
    />
</template>
